import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-end-item-allocation-components',
  templateUrl: './end-item-allocation-components.component.html',
  styleUrls: ['./end-item-allocation-components.component.css']
})
export class EndItemAllocationComponentsComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.EndItemAllocationComponents.columns;
    this.data = this.report.EndItemAllocationComponents.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.EndItemAllocationComponents.data;
    const gridInstance = this.gridContext.getInstance('EndItemAllocationComponents');
    gridInstance.loadData(this.data);
  }
}


// WEBPACK FOOTER //
// ./src/app/end-item-allocation-components/end-item-allocation-components.component.ts